import { render } from "./TheNavigation.vue?vue&type=template&id=20682d14&scoped=true"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"

import "./TheNavigation.vue?vue&type=style&index=0&id=20682d14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20682d14"

export default script